import Api from './BaseRequest'

const GetCoordinates = (id) => {
    return Api.Get('/practice/' + id + '/coordinates');
};

const Delete = (id) => {
    return Api.Delete('/practice/' + id);
}

const cacheRoadsApiResponse = (driveId, batchNumber, data) => {
    return Api.Put('/student/practice_driving/' + driveId + '/coordinates/store_api_results', {
        batch_number: batchNumber,
        data: data,
    });
}

export default {
    GetCoordinates,
    Delete,
    cacheRoadsApiResponse,
}